import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from '@core/core.module';
import { NgxsStoreModule } from './ngxs-store/ngxs-store.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { API_BASE_URL } from '@core/services/api.service';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { AgmCoreModule } from '@agm/core';

@NgModule({
    imports: [
        CommonModule,
        BrowserModule,
        BrowserAnimationsModule,
        CoreModule,
        AppRoutingModule,
        NgxsStoreModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: true,
            registrationStrategy: 'registerWhenStable:30000'
        }),
        AgmCoreModule.forRoot({
            apiKey: environment.googleApiKey,
            libraries: ['places', 'geometry']
        }),
    ],
    providers: [{ provide: API_BASE_URL, useFactory: getBaseUrl }, { provide: MAT_DATE_LOCALE, useValue: 'en-ZA' }],
    bootstrap: [AppComponent]
})
export class AppModule { }

export function getBaseUrl(): string {
    return environment.webApiBaseAddress;
}
